module.exports = __webpack_public_path__ + "static/media/trend-portfolio bg6.83a927ed.png";